import {Form, formsStore} from '../../../stores/Form';

const {getActiveForm} = formsStore;

export const isActiveForm = (currentForm: Form) => {
    const activeForm = getActiveForm();
    return activeForm === currentForm && !formsStore.onBackground;
};
